


export var Method; (function (Method) {
  const GET = 'GET'; Method["GET"] = GET;
  const POST = 'POST'; Method["POST"] = POST;
  const DELETE = 'DELETE'; Method["DELETE"] = DELETE;
  const PUT = 'PUT'; Method["PUT"] = PUT;
  const PATCH = 'PATCH'; Method["PATCH"] = PATCH;
})(Method || (Method = {}));












export class ProxyFetch {
    target;
    discoveryApi;

  constructor(options) {
    this.target = options.target;
    this.discoveryApi = options.discoveryApi;
  }

  async fetchApi(endpoint, fetchParams) {
    const proxyBackendBaseUrl = await this.discoveryApi.getBaseUrl('proxy');
    const url = `${proxyBackendBaseUrl}/${this.target}/${endpoint}`;
    return fetch(url, { ...fetchParams });
  }
}

export const initProxy = (
  target,
  discoveryApi,
) => {
  return new ProxyFetch({
    target,
    discoveryApi,
  });
};
